import Vue from 'vue'
import Vuex from 'vuex'

import user from './modules/user'
import dict from './modules/dict'
import region from './modules/region'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        user,
        dict,
        region
    },
    state: {
        menuIndex: 1,
        isMobile: false,
        showLogin: false,

    },
    getters
})

export default store
